export default __webpack_public_path__ + "static/salondeals-logo-verlenging-NL~bpcqSAuC-8227c2f2d712d68ec813bc7f734f4d4a.png";